import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  SimpleGrid,
  Icon,
  HStack,
  Button,
  LinkBox,
  LinkOverlay,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiFileText, FiDownload } from "react-icons/fi";

const licenses = [
  {
    title: "مجوز فعالیت تامین سرمایه",
    issuer: "سازمان بورس و اوراق بهادار",
    file: "/images/license-files/مجوز فعالیت تامین سرمایه.pdf",
  },
  {
    title: "مجوز سبدگردانی",
    issuer: "سازمان بورس و اوراق بهادار",
    file: "/images/license-files/مجوز سبدگردانی.pdf",
  },
  {
    title: "مجوز تمدید سبدگردانی",
    issuer: "سازمان بورس و اوراق بهادار",
    file: "/images/license-files/مجوز تمدید سبدگردانی.pdf",
  },
  {
    title: "مجوز اولیه سبدگردانی شرکت تامین سرمایه امید",
    issuer: "سازمان بورس و اوراق بهادار",
    file: "/images/license-files/مجوز_اولیه_سبدگردانی_شرکت_تامین_سرمایه_امید_.pdf",
  },
];

export const SectionLicenses = () => {
  const headingColor = useColorModeValue("gray.900", "white");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const cardBg = useColorModeValue("white", "dark.500");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const labelColor = useColorModeValue("gray.500", "gray.400");

  return (
    <Box>
      <Container maxW="container.xl">
        <VStack spacing={8} align="stretch">
          <VStack spacing={3} align="center" textAlign="center">
            <Heading
              as="h2"
              fontSize={{ base: "xl", md: "2xl", lg: "3xl" }}
              fontWeight="bold"
              color={headingColor}
            >
              مجوزها و گواهی‌ها
            </Heading>
            <Text fontSize={{ base: "sm", md: "md" }} color={textColor}>
              تمامی مجوزهای فعالیت شرکت از مراجع رسمی
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
            {licenses.map((lic) => (
              <LinkBox
                key={lic.title}
                bg={cardBg}
                borderRadius="xl"
                border="1px solid"
                borderColor={borderColor}
                p={5}
                _hover={{ shadow: "md", borderColor: "brand.200" }}
                transition="all 0.3s"
              >
                <VStack align="flex-start" spacing={2}>
                  <HStack>
                    <Icon
                      verticalAlign="middle"
                      as={FiFileText as any}
                      color="brand.500"
                      boxSize={4}
                    />
                    <LinkOverlay href={lic.file} isExternal>
                      <Text fontWeight="bold" fontSize="sm" color={headingColor}>
                        {lic.title}
                      </Text>
                    </LinkOverlay>
                  </HStack>
                  <Text fontSize="xs" color={textColor}>
                    {lic.issuer}
                  </Text>
                  <Text fontSize="xs" color={labelColor}>
                    فایل مرجع مجوز در قالب PDF
                  </Text>
                  <Button
                    as="a"
                    href={lic.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    size="xs"
                    variant="ghost"
                    colorScheme="brand"
                    rightIcon={
                      <Icon verticalAlign="middle" as={FiDownload as any} />
                    }
                  >
                    مشاهده و دانلود مجوز
                  </Button>
                </VStack>
              </LinkBox>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};
